export default function round(number: number|string, decimals: number) {
    if (number !== 0) {
        return (Math.round(parseFloat(<string>number) * 100) / 100).toFixed(decimals)
    } else {
        return parseFloat(String(number));
    }
}